module.exports = __webpack_public_path__ + "img/icon_bms5.4e047a37.jpg";